import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import Header from './header';
import Navigation from './navigation';
import BottomFooter from './footer';
import transform from 'chipDataTransform';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Iframe from './iframe';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();

        window.addEventListener(
            'message',
            event => {
                if (event?.data?.rjhPath) {
                    window.open(
                        `${location.protocol}//${location.hostname}/hkSub?iframeUrl=${event.data.rjhPath}`,
                        'target',
                        '',
                    );
                }
            },
            false,
        );
    }

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const { nav, search, logo, subLogo, footer, navigation, iframeList } = content;

        const headerData = {
            nav,
            search,
            logo,
            subLogo,
        };

        const footerData = {
            footer,
        };

        return (
            <>
                <Header content={headerData} />
                <Chip id="30007" type="struct" title="财经导航" groupName="导航栏" content={navigation}>
                    <Navigation />
                </Chip>
                <div className={styles.col_1000}>
                    <Chip id="260423" type="struct" title="行情中心" groupName="行情中心" content={iframeList}>
                        <Iframe />
                    </Chip>
                </div>
                <BottomFooter content={footerData} />
                <ChipEdit transform={transform} />
            </>
        );
    }
}

export default errorBoundary(Layout);
